var React = require('react');

function IcoFb (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_686_16020)","key":0},React.createElement("path",{"d":"M32.3532 17.6473C32.3532 9.52964 25.7649 2.94141 17.6473 2.94141C9.52964 2.94141 2.94141 9.52964 2.94141 17.6473C2.94141 24.7649 8.00023 30.6914 14.7061 32.0591V22.0591H11.7649V17.6473H14.7061V13.9708C14.7061 11.1326 17.0149 8.82376 19.8532 8.82376H23.5296V13.2355H20.5885C19.7796 13.2355 19.1179 13.8973 19.1179 14.7061V17.6473H23.5296V22.0591H19.1179V32.2796C26.5443 31.5443 32.3532 25.2796 32.3532 17.6473Z","fill":"black"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_686_16020"},React.createElement("rect",{"width":"35.2941","height":"35.2941","fill":"white"})))]);
}

IcoFb.defaultProps = {"viewBox":"0 0 36 36","fill":"none"};

module.exports = IcoFb;

IcoFb.default = IcoFb;
